import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const DatenschutzText = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 6
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        px: {
          md: '130px !important'
        }
      }}
    >
      <Typography
        color="textSecondary"
        sx={{ mb: 2 }}
        variant="body1"
        align="justify"
      >
        <h3>Datenschutz</h3>
        Stand der Erklärung: Nov. 2021
        <br />
        <br />
        <h3>Einleitung</h3>
        Wir freuen uns sehr über Ihr Interesse an unserem Unternehmen. Datenschutz hat in unserem Hause
        einen hohen Stellenwert. Mit dieser Erklärung informieren wir Sie über Art und Umfang sowie über
        Zweck und Rechtsgrundlage der Verarbeitung personenbezogener Daten auf dieser Webseite und
        auf etwaigen Onlinepräsenzen in sozialen Netzwerken. Darüber hinaus kommunizieren wir an
        dieser Stelle unsere Informations- und Hinweispflichten für die Verwendung von
        personenbezogenen Daten in unserem Hause.
        <br />
        <br />
        Diese Datenschutzerklärung spricht Frauen und Männer gleichermaßen an. Zur besseren Lesbarkeit
        wird jedoch nur die männliche Sprachform verwendet.
        <br />
        <br />
        <h3>Name und Anschrift des Verantwortlichen</h3>
        Der Verantwortliche im Sinne der Datenschutz-Grundverordnung (DSGVO) und anderer nationaler
        Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist
        das im Impressum genannte Unternehmen.
        <br />
        <br />
        <h3>Kontakt zum Datenschutzbeauftragten</h3>
        Wir sind nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet. Bei Fragen zum Thema
        Datenschutz kontaktieren sie uns bitte über unser Kontaktformular.
        <br />
        <br />
        <h3>Grundlegendes zur Verarbeitung von personenbezogenen Daten</h3>
        Wir erheben und verarbeiten personenbezogene Daten unserer Nutzer nur, soweit dies zur
        Bereitstellung einer funktionsfähigen Webseite bzw. der Erbringung von Leistungen unseres
        Unternehmens erforderlich ist. Die Verarbeitung erfolgt nur mit Ihrer Einwilligung oder sofern eine
        gesetzliche Vorschrift uns zur Verarbeitung verpflichtet oder sie gestattet.
        <br />
        <br />
        Dabei hat die Sicherheit Ihrer personenbezogenen Daten für uns eine hohe Priorität. Wir schützen
        daher Ihre Daten durch technische und organisatorische Maßnahmen, um einem Missbrauch der
        Nutzung vorzubeugen. Die getroffenen Maßnahmen überprüfen wir regelmäßig und passen diese
        aktuellen technischen Gegebenheiten an. Darüber hinaus verpflichten wir alle Mitarbeiter auf
        Vertraulichkeit nach §28 DSGVO.
        <br />
        <br />
        Zwecke und Rechtsgrundlage der Verarbeitung, Weitergabe an Dritte und ins Ausland
        Ihre Daten verarbeiten wir für folgende Zwecke:
        <br />
        <br />
        Erfüllen von neuen oder bestehenden Vertragsverhältnissen oder zur Durchführung von
        vorvertraglichen Maßnahmen, z.B. das Erstellen von Angeboten
        <br />
        Versand von Marketinginformationen
        <br />
        Bearbeiten von Anfragen, z.B. im Rahmen unserer Kerntätigkeit oder für Bewerbungsschreiben
        <br />
        Bereitstellung von Telemedien, z.B. unserer Webseite oder E-Mail
        <br />
        Dabei verarbeiten wir die Daten aufgrund der Rechtsgrundlagen des Art. 6 Abs. 1 DSGVO:
        <br />
        <br />
        Art. 6 Abs. 1 lit. a DSGVO: Verarbeitungsvorgänge, die auf Ihrer Einwilligung beruhen
        <br />
        Art. 6 Abs. 1 lit. b DSGVO: Verarbeitungsvorgänge zur Erfüllung eines Vertrages bzw.
        vorvertraglicher Maßnahmen, z.B. ein Kauf- oder Dienstleistungsvertrag bzw. die Einholung eines
        Angebots
        <br />
        Art. 6 Abs. 1 lit. c DSGVO: Verarbeitungsvorgänge, zu denen wir rechtlich verpflichtet sind, z.B.
        die Aufbewahrung aus steuerlichen Gründen
        <br />
        Art. 6 Abs. 1 lit. f DSGVO: Verarbeitungsvorgänge, die wir auf Grundlage unserer berechtigten
        Interessen durchführen, z.B. die Weitergabe Ihrer Daten an Postdienstleister zwecks Versendung
        von Post oder an einen Steuerberater. Hierzu gehört auch das Speichern von Informationen zur
        Webseitennutzung zum Zwecke der Optimierung unserer Webseite.
        <br />
        <br />
        Auch die Weitergabe Ihrer Daten an Dritte stützt sich auf die obigen Erlaubnistatbestände und
        erfolgt nur im Rahmen eines Auftragsverarbeitungsvertrages oder sofern andere
        Verschwiegenheitsverpflichtungen bestehen, hierzu gehören Berufsgeheimnisträger oder
        Versanddienstleister.
        <br />
        <br />
        <h3>Dauer der Speicherung, Löschung personenbezogener Daten</h3>
        Personenbezogene Daten werden nur für den Zeitraum verarbeitet und gespeichert, der zur
        Erfüllung der Verarbeitungszwecke erforderlich ist. Nach Erfüllung des Zwecks werden Ihre Daten
        bei uns gelöscht oder gesperrt, sofern wir keiner gesetzlichen Speicherpflicht mehr unterliegen.
        <br />
        <br />
        <h3>Datenweitergabe an Dritte</h3>
        Grundsätzlich können wir personenbezogene Daten an folgende Dritte weitergeben:
        <br />
        • Öffentliche Stellen bei Vorliegen vorrangiger Rechtsvorschriften
        <br />
        • intern für Zwecke der internen Kommunikation, der Betreuung, Verwaltung und zu
        Abrechnungszwecken
        <br />
        • Auftragsdatenverarbeiter
        <br />
        • Servicepartner für begleitende Services, soweit durch die betroffene Person entsprechende
        Dienstleistungen abgefragt werden
        <br />
        <br />
        <h3>Erhebung von Zugriffsdaten und Logfiles / Amazon Web Services (AWS)</h3>
        Unsere Webseite betreiben wir im Rechenzentrum von Amazon Web Services EMEA SARL, 38
        Avenue John F. Kennedy, 1855 Luxemburg.
        <br />
        <br />
        Beim Besuch unserer Webseite werden personenbezogene Daten auf den Servern von AWS
        verarbeitet. In diesem Zusammenhang können auch personenbezogene Daten an das
        Mutterunternehmen von AWS in die USA übermittelt werden. Bei der Datenübertragung in die USA
        stützt sich Amazon auf EU-Standardvertragsklauseln. Details finden Sie unter:
        https://aws.amazon.com/de/blogs/security/aws-gdpr-data-processing-addendum/.
        <br />
        <br />
        Weitere Informationen finden Sie in der Datenschutzerklärung von AWS:
        https://aws.amazon.com/de/privacy/?nc1=f_pr.
        <br />
        <br />
        Die Verarbeitung von Zugriffsdaten erfolgt auf der Grundlage unserer berechtigten Interessen
        gemäß Art. 6 Abs. 1 lit. f. DSGVO.
        <br />
        Die verarbeitenden Datenkategorien sind: Name der abgerufenen Webseite, Datum und Uhrzeit des
        Abrufs, übertragene Datei und Datenmenge, Meldung über den Abruferfolg oder -misserfolg,
        Browsertyp und Browserversion, das Betriebssystem, Referrer URL (die vorher besuchte Seite)
        sowie Ihre IP-Adresse.Logdateien werden aus Sicherheitsgründen (z.B. Evaluieren von Fehlern,
        Aufklärung von Straftaten) erhoben und für eine Dauer von 90 Tagen gespeichert und im Anschluss
        gelöscht. Sofern Daten zu Beweiszwecken weiterhin erforderlich sind, werden diese bis zur
        endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.
        <br />
        <br />
        <h3>Einbettung von Youtube</h3>
        Zur Verbesserung unseres Online-Angebotes binden wir mit ihrer Einwilligung gemäß Art. 6 Abs. 1
        lit. a DSGVO Videos der Video-Plattform YouTube des Anbieters Google Ireland Limited, Gordon
        House, Barrow Street, Dublin 4, Irland, ein. Durch die Nutzung von Youtube werden auch von
        Google Daten über die Verwendung der Videos erhoben und eventuell gespeichert.
        <br />
        Die Datenschutzerklärung von Youtube finden sie unter: https://www.google.com/policies/privacy/
        <br />
        <br />
        <h3>Verwendung von Cookies und Trackinginformationen</h3>
        Bei Cookies handelt es sich um Dateien, die vom Internetbrowser auf dem Computersystem des
        Nutzers gespeichert werden. Beim Aufruf dieser Webseite werden Cookies im Browser-Speicher
        der betroffenen Person gespeichert.
        <br />
        <br />
        Sie können die Speicherung von Cookies im Browser unterbinden, die Seite wird dann u.U. jedoch
        nur eingeschränkt funktionieren. Sinnvoller ist an dieser Stelle die Einstellung zur Löschung aller
        Cookies nach Beendigung der jeweiligen Browser-Sitzung, was auf unserer Seite ohne
        Einschränkung funktioniert und ein Wiedererkennen beim nächsten Besuch mit allen für Sie
        positiven und negativen Konsequenzen unterbindet.
        <br />
        <br />
        Wir verwenden technische Cookies, da dies technisch notwendig für den Betrieb der angebotenen
        Dienstleistung ist gemäß Art 6 Abs. 1 lit. f DSGVO, d.h. zur Wahrung unseres berechtigten
        Interesses.
        <br />
        Technische Cookies dienen dazu, einen Benutzer bei erneutem Aufruf der Webseite
        wiederzuerkennen und so z.B. getätigte Spracheinstellungen, einen Warenkorb o.ä. über eine Surf-
        Sitzung hinaus zu speichern.
        <br />
        <br />
        <h3>Online Konto und Benutzerregistrierung</h3>
        Im Rahmen unseres Online Kontos speichern wir von Ihnen die folgenden Daten:
        E-Mail*, Login ID* und Passwort*, Name, Adressdaten, Telefonnummer, Einstellungen (z.B.
        Trainingspläne) für die Nutzung der Online-Funktionen (z.B. Trainingspläne).
        Name*, Adressdaten*, Telefonnummer*, Zahlungsdaten*: Zu Abrechnungszwecken beim Buchen
        kostenpflichtiger Leistungen. Im Falle einer Buchung kostenpflichtiger Funktionen sind diese
        Datenfelder verpflichtend, ansonsten optional
        <br />
        <br />
        *Pflichtfelder
        <br />
        <br />
        <h3>Weitergabe personenbezogener Daten an Zahlungsanbieter</h3>
        Zur Abwicklung von Zahlungen geben wir Ihre Zahlungsdaten an das mit der Zahlung beauftragte
        Unternehmen weiter. Die Rechtsgrundlage für die Weitergabe an Zahlungsdienstleister ist die
        Wahrung unseres berechtigten Interesses gemäß Art. 6 Abs. 1 lit. b. DSGVO.
        Es gelten darüber hinaus die Geschäftsbedingungen und Datenschutzhinweise der entsprechenden
        Zahlungsdienstleister. Die Weitergabe Ihrer Daten erfolgt ausschließlich zum Zwecke der
        Zahlungsabwicklung mit dem Zahlungsdienstleister und nur insoweit, als sie hierfür erforderlich ist.
        <br />
        <br />
        <h3>Kontaktaufnahme</h3>
        Bei einer Kontaktaufnahme (z.B. via Kontaktformular, E-Mail, Telefon oder via sozialer
        Netzwerke) werden die personenbezogenen Daten des Nutzers zur Bearbeitung der Kontaktanfrage
        gem. Art. 6 Abs. 1 lit. b DSGVO, d.h. zur Erfüllung eines Vertrags oder vorvertraglicher
        Maßnahmen verarbeitet. Hierzu werden Ihre Daten ggf. in ein Kundenverwaltungsprogramm
        (CRM-System) überführt. Bitte nehmen Sie zur Kenntnis, dass wir gemäß der GoBD zur E-Mail-
        Archivierung verpflichtet sind; eine vollständige Löschung uns übersandter E-Mails (aus unserem
        Archivsystem) ist daher nicht möglich.
        <br />
        <br />
        <h3>Keine automatisierte Entscheidungsfindung</h3>
        Wir verzichten auf eine automatische Entscheidungsfindung im Sinne von Art. 22 DS-GVO.
        <br />
        <br />
        <h3>Aktualisierung der Datenschutzerklärung</h3>
        Wir aktualisieren diese Datenschutzerklärung von Zeit zu Zeit im Hinblick auf neue gesetzliche
        Grundlagen oder Rechtsprechungen oder veränderte Verarbeitung in unserem Unternehmen. Wir
        behalten uns Änderungen daher ausdrücklich vor.
        <br />
        <br />
        <h3>Hinweis auf die Betroffenenrechte</h3>
        Sofern wir personenbezogene Daten von Ihnen verarbeiten, so sind Sie Betroffener im Sinne der
        DSGVO und Sie haben folgende Rechte gegenüber der verantwortlichen Stelle:
        <h3>Recht auf Auskunft und Datenübertragbarkeit</h3>
        Sie haben das Recht, eine Auskunft über die zu Ihrer Person gespeicherten Daten zu verlangen.
        Sie haben das Recht, die angeforderten Daten in einem gängigen, maschinenlesbaren Format zu
        erhalten.
        <br />
        <br />
        <h3>Recht auf Berichtigung</h3>
        Sie haben das Recht, von dem Verantwortlichen die Berichtigung Sie betreffender unrichtiger
        personenbezogener Daten zu verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung
        haben Sie
        das Recht, die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.
        <br />
        <br />
        <h3>Recht auf Einschränkung</h3>
        Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der Sie
        betreffenden personenbezogenen Daten verlangen:
        <br />
        <br />
        1) Die Richtigkeit der personenbezogenen Daten wird von der betroffenen Person bestritten, und
        zwar für eine Dauer, die es dem Verantwortlichen ermöglicht, die Richtigkeit der
        personenbezogenen Daten zu überprüfen.
        <br />
        2) Die Verarbeitung ist unrechtmäßig und die betroffene Person lehnt die Löschung der
        personenbezogenen Daten ab und verlangt stattdessen die Einschränkung der Nutzung der
        personenbezogenen Daten.
        <br />
        3) Der Verantwortliche benötigt die personenbezogenen Daten für die Zwecke der Verarbeitung
        nicht länger, die betroffene Person benötigt sie jedoch zur Geltendmachung, Ausübung oder
        Verteidigung von Rechtsansprüchen, oder wenn
        <br />
        4) die betroffene Person Widerspruch gegen die Verarbeitung einlegt, solange noch nicht feststeht,
        ob die berechtigten Gründe des Verantwortlichen gegenüber denen der betroffenen Person
        überwiegen.
        <br />
        <br />
        Wurde die Verarbeitung eingeschränkt, so dürfen diese personenbezogenen Daten – von ihrer
        Speicherung abgesehen – nur mit Einwilligung der betroffenen Person oder zur Geltendmachung,
        Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen
        natürlichen oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der
        Union oder eines Mitgliedstaats verarbeitet werden. Wir informieren Sie, bevor die Einschränkung
        aufgehoben wird.
        <br />
        <br />
        <h3>Recht auf Löschung</h3>
        Unter den folgenden Voraussetzungen können Sie die Löschung der Verarbeitung der Sie
        betreffenden personenbezogenen Daten verlangen:
        <br />
        1) Die personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise
        verarbeitet wurden, nicht mehr notwendig.
        <br />
        2) Die betroffene Person widerruft Ihre Einwilligung und es fehlt an einer anderweitigen
        Rechtsgrundlage für die Verarbeitung.
        <br />
        3) Die betroffene Person legt Widerspruch gegen die Verarbeitung ein und es liegen keine
        vorrangigen berechtigten Gründe für die Verarbeitung vor.
        <br />
        4) Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.
        <br />
        5) Die Löschung der personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung
        nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche
        unterliegt.
        <br />
        6) Die personenbezogenen Daten wurden in Bezug auf die Nutzung von Webdiensten erhoben.
        <br />
        <br />
        <h3>Recht auf Widerruf einer Einwilligungserklärun</h3>
        Sie haben das Recht, eine Einwilligung in die Verarbeitung von personenbezogenen Daten jederzeit
        zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der
        Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
        <br />
        <br />
        <h3>Recht auf Unterrichtung</h3>
        Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung geltend
        gemacht, sind wir verpflichtet, alle Empfänger über diesen Sachverhalt zu unterrichten, an die diese
        Daten weitergegeben wurden, es sei denn dies ist mit einem unverhältnismäßig hohen Aufwand
        verbunden oder unmöglich.
        <br />
        <br />
        <h3>Widerspruchsrecht</h3>
        SIE HABEN DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
        JEDERZEIT GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN
        WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN GESTÜTZTES
        PROFILING. DER VERANTWORTLICHE VERARBEITET DIE PERSONENBEZOGENEN DATEN NICHT MEHR,
        ES SEI DENN, ER KANN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
        NACHWEISEN, DIE DIE INTERESSEN, RECHTE UND FREIHEITEN DER BETROFFENEN PERSON
        ÜBERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER
        VERTEIDIGUNG VON RECHTSANSPRÜCHEN.
        <br />
        WERDEN PERSONENBEZOGENE DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO
        HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER
        PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH
        FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT.
        <br />
        <br />
        <h3>Automatisierte Entscheidung im Einzelfall einschließlich Profiling</h3>
        Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung –
        einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden, die Ihnen gegenüber
        rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt. Dies gilt nicht,
        wenn die Entscheidung
        <br />
        1) für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem Verantwortlichen
        erforderlich ist,
        <br />
        2) aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der Verantwortliche
        unterliegt, zulässig ist und diese Rechtsvorschriften angemessene Maßnahmen zur Wahrung Ihrer
        Rechte und Freiheiten sowie Ihrer berechtigten Interessen enthalten oder
        <br />
        3) mit Ihrer ausdrücklichen Einwilligung erfolgt.
        <br />
        Entscheidungen nach Absatz 2 dürfen nicht auf besonderen Kategorien personenbezogener Daten
        nach Art. 9 Abs. DSGVO Absatz 1 beruhen, sofern nicht Art. 9 Abs. 2 lit. a oder g DSGVO gilt und
        angemessene Maßnahmen zum Schutz der Rechte und Freiheiten sowie der berechtigten Interessen
        der betroffenen Person getroffen wurden.
        <br />
        Hinsichtlich der in (1) und (3) genannten Fälle trifft der Verantwortliche angemessene Maßnahmen,
        um die Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren, wozu mindestens das
        Recht auf Erwirkung des Eingreifens einer Person seitens des Verantwortlichen, auf Darlegung des
        eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.
        <br />
        <br />
        <h3>Recht auf Beschwerde bei einer Aufsichtsbehörde</h3>
        Sie haben das Recht auf Beschwerde bei einer Aufsichtsbehörde, unbeschadet eines anderweitigen
        verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs, insbesondere in dem Mitgliedstaat Ihres
        gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes,
        wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten
        gegen die DSGVO verstößt.
        Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den
        Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich der
        Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.
        <br />
        <br />
        <h3>Nichtbereitstellung personenbezogener Daten</h3>
        Sofern Sie uns personenbezogene Daten, die wir für vertragliche Zwecke benötigen nicht
        bereitstellen, so hat diese Nichtbereitstellung im Allgemeinen zur Folge, dass der Vertrag nicht
        geschlossen werden kann. Wir können Sie im Einzelfall darüber aufklären, ob eine Bereitstellung
        gesetzlich verpflichtend oder vertraglich vorgeschrieben ist und welche Folgen die
        Nichtbereitstellung im Einzelfall hätte.
        <br />
        <br />
        <br />
      </Typography>
    </Container>
  </Box>
);

export default DatenschutzText;
